module.exports = __webpack_public_path__ + "static/media/雅BU1821瓷砖.e6e60e63.pdf";